'use client'

import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { PropsWithChildren } from 'react'
import { getCommonPosthogSettings } from '@tucan/utils'

const { posthogConfig, posthogKey } = getCommonPosthogSettings()
posthog.init( posthogKey, posthogConfig)

export function PhProvider({ children }: PropsWithChildren) {
  return (
    <PostHogProvider client={posthog}>
      {children}
    </PostHogProvider>
  )
}
